import { CryptoService } from './../../../../../shared/services/crypto.service';
import { PackService } from './../../../../contributor/components/profile/contributors/pack/services/pack.service';
import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
  inject,
  Inject,
  NgZone,
  OnInit,
  PLATFORM_ID,
  QueryList,
  REQUEST,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, firstValueFrom, Subscription } from 'rxjs';
import { AuthService } from '../../../../auth/services/auth.service';
import { SharedService } from '../../../../../shared/services/shared.service';
import { Category } from '../../../../admin-panel/components/pages/category/models/category';
import { CategoryService } from '../../../../admin-panel/components/pages/category/services/category.service';
import { environment } from '../../../../../environments/environment';
import { DropdownToggleService } from '../../../../../shared/services/dropdown-toggle.service';
import {
  CategoryPackVM,
  IconPack,
  IconPackDetail,
} from '../../../../contributor/components/profile/contributors/pack/models/pack';
import { CacheService } from '../../../../../shared/services/cache.service';
import { SpecialCharactersFormatter } from '../../../../../utils/convert-special-formatter';
import { ProxyServiceFetchURLService } from '../../../../../shared/services/proxy-service-fetch-url.service';
import { LisenceEnum } from '../../../../../shared/models/license';
import { AppRoutesUtils } from '../../../../../utils/app-routes-util';
import { AssetGalleryParams } from '../../../../../shared/models/asset-gallery-params';
import { BlobService } from '../../../../../shared/services/blob.service';
import { TopSearchKeywords } from '../../../models/top-search-keyword';
import { PublicService } from '../../../services/public.service';
import { GalleryLayoutService } from '../../pages/gallery/services/gallery-layout.service';
import { MatDialog } from '@angular/material/dialog';
import { TopSearchANDViews } from '../../../models/top-searchAndView';
import { SearchsCollection } from '../../../models/searchCollections';
import { FormatEnum } from '../../../../../shared/models/format-enum';
import { FormatterUtil } from '../../../../../utils/formatter-util';
import { HttpErrorResponse } from '@angular/common/http';
import { ERROR_ROUTE_SEGMENTS } from '../../../../../shared/constants/error-routes';
import { SeoMetaTags } from '../../../../../shared/models/seoMetaTags';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { HeaderSearchService } from '../../../services/header-search.service';
import { Package } from '../../../../contributor/components/profile/subscription/models/Package';
import { PackageService } from '../../../../contributor/components/profile/subscription/services/package.service';
import { EventCategory } from '../../../../admin-panel/components/pages/event-category/models/event-category';
import { appendBlobSasToken } from '../../../../../shared/utils/blob-url-util';
import { SchemaService } from '../../../../../shared/services/schema.service';
import { syncBlobTokens } from '../../../../../shared/utils/blob-token-sync';

@Component({
  selector: 'app-landing-page',
  standalone: false,
  /** Avoid SSR + client hydration reconciling this route twice (duplicate cards / rows). */
  host: { ngSkipHydration: '' },
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.css',
})
export class LandingPageComponent implements OnInit {
  encodeURIComponent = encodeURIComponent;
  @ViewChild('cardsStrip') cardsStrip?: ElementRef<HTMLElement>;
  /** Index of the first fully visible category card (drives the pagination dots below xl). */
  activeCardIndex = 0;
  images = [
    './assets/theme/illustrations/Illustration1.svg',
    './assets/theme/illustrations/Illustration2.svg',
    './assets/theme/illustrations/Illustration3.svg',
  ];
  readonly packSkeletonRowCellClass =
    'w-[310px] shrink-0 min-width-mobile lg:w-full lg:min-w-0 lg:max-w-none';
  private readonly packGridGapPx = 16;
  private readonly packGridMinPx = 310;
  private readonly packRowTabletMax = 5;
  showGallery: boolean = true;
  search: string = '';
  livesearch: string = '';

  categories: Category[] = [];
  key: string = 'categories';
  colors: string[] = ['#EFF9FF', '#FFF6ED', '#F9EFFF', '#F1FFEF','#FDF2FF'];
  paddingClasses = [
 'py-[12px] px-[21px]',
 'lg:pt-[6px] pt-[0px] px-[21px] w-full',
  'lg:pt-[6px] pt-[0px] px-[21px]',
    'lg:pt-[6px] pt-[0px] px-0 w-full',
  'lg:pt-[6px] pt-[0px] px-[21px] w-full',

];
Cardimages: string[] = [
  '../../../../../assets/landing-page/3d-gaphics-img-3x.png',
  '../../../../../assets/landing-page/data2.json',
  '../../../../../assets/landing-page/illustration-img-3x.png',
  '../../../../../assets/landing-page/sticker-img-3x.png',
  '../../../../../assets/landing-page/vector-icon-img-3x.png'
];
  packCategories: CategoryPackVM[] = [];
  categorySelected: string = 'All Assets';
  loading: boolean = false;
  screenWidth!: number;
  isMobileView: boolean = false;

  encodedToken!: string;
  content: string = LisenceEnum.All.toString().toLowerCase();
  freeContent: boolean = false;
  premiumContent: boolean = false;
  allContent: boolean = false;
  lisenceEnum: any = LisenceEnum;
  categoryLoading: boolean = false;
  keywordsLoading: boolean = false;
  topSearchKeywords: TopSearchKeywords[] = [];
  topSearchsKeywords: TopSearchKeywords[] = [];
  topSearch: SearchsCollection[] = [];
  iconPackDetail: IconPackDetail[] = [];
  formatEnum = FormatEnum;
  subscribedPackage: boolean = false;
   packages: Package[] = [];
   isSearchOpen: any;
   token: string | null = null;
   readonly appendBlobSasToken = appendBlobSasToken;
   liveSearch: string [] = [];
   isUserLogin!: boolean;
   searchTimeout: any;
   activeIndex: number = -1;
   isFestivitiesLoading = false;
  /** First five events from cache (same source as festivities gallery). */
  parentFestivities: EventCategory[] = [];
  topFestivities: EventCategory[] = [];
  private scrollHandler = () => this.onScroll();
  private request = inject(REQUEST, { optional: true });
  private readonly destroyRef = inject(DestroyRef);
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private sharedService: SharedService,
    private cdr: ChangeDetectorRef,
    private cacheService: CacheService,
    private dropdownService: DropdownToggleService,
    private packService: PackService,
    private blobService: BlobService,
    private publicService: PublicService,
    public proxyServiceFetchURLService: ProxyServiceFetchURLService,
    public galleryLayoutService: GalleryLayoutService,
    private dialog: MatDialog,
    private titleService: Title,
    private metaService: Meta,
    private HeaderSearchService: HeaderSearchService,
    private ngZone: NgZone,
    private packageService: PackageService,
    private schemaService: SchemaService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    syncBlobTokens({
      blobService: this.blobService,
      destroyRef: this.destroyRef,
      setToken: (t) => (this.token = t),
      cdr: this.cdr,
    });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const currentRoute = this.activatedRoute.snapshot.firstChild;
        if (currentRoute) {
          this.showGallery = currentRoute.data?.['showGallery'] !== false;
        } else {
          this.showGallery = true;
        }
      });
  }
  async ngOnInit() {
    this.getCategoriesFromCache();
    this.getFestivities();
    this.getTopSearchKeywords();
    this.loading = true;
    // Start in the final state (hidden at the top of the page). Showing it first on small screens and
    // hiding it after the packs load pushed the hero up and counted as layout shift.
    this.HeaderSearchService.setHeaderSearchState(false);
    this.isUserLogin = this.sharedService.isUserLoggedIn();
    this.authService.refreshComponent$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((refresh) => {
        if (refresh) {
          this.isUserLogin = this.sharedService.isUserLoggedIn();
          this.cdr.markForCheck();
        }
      });
    // Token refresh runs in parallel with the packs API call instead of blocking it (and the hero).
    const tokenReady = this.blobService.refreshTokenIfNeeded().then(() => {
      this.token = this.blobService.getToken();
      this.cdr.markForCheck();
    });
    this.setSeoMetaTags(
        new SeoMetaTags(
          'Creative Stall | 3D Icons, Lottie Animations & Illustrations','A marketplace for creative assets. Download free & premium SVG icons, illustrations, 3D graphics, and Lottie animations to speed up your design workflow.',environment.publicSiteOrigin

        )

      );
    this.applyLandingPageSchema();
    this.sharedService.currentSearch.subscribe((e) => {
      this.search = e.trim();
    });
    this.sharedService.categorySearch.subscribe((e) => {
      this.categorySelected = e;
    });
    this.content = this.sharedService.getContent();

    // this.getTopSearchANDViews();
    await Promise.all([this.getCategoryPacks(), tokenReady]);
    // getDeviceWidth reads window.innerWidth, which does not exist during server rendering.
    if (this.isBrowser) {
      this.getDeviceWidth(null);
    }
    this.HeaderSearchService.setHeaderSearchState(false);
    this.getPackages();
  }
  get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }
  @HostListener('window:resize', ['$event'])
  getDeviceWidth(event?: any) {
    this.measuredPackRowWidth = undefined; // layout may have changed: measure again once
    this.screenWidth = window.innerWidth;
    this.isMobileView = this.screenWidth < 1280;
    this.updateVisibleCount();

  }
  isLottieAsset(path: string | null | undefined): boolean {
    return !!path && path.toLowerCase().endsWith('.json');
  }


  setSeoMetaTags(seoMetaTags: SeoMetaTags) {
    
    const pageTitle = seoMetaTags.pageTitle;
    const pageDescription = seoMetaTags.pageDescription;
    const pageUrl = seoMetaTags.pageUrl;
    const pageImage = seoMetaTags.pageImage;

    // Set Title
    this.titleService.setTitle(pageTitle);

    // Set Meta Description
    this.metaService.updateTag({
      name: 'description',
      content: pageDescription
    });

    // Open Graph Tags
    this.metaService.updateTag({
      property: 'og:title',
      content: pageTitle
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: pageDescription
    });

    this.metaService.updateTag({
      property: 'og:url',
      content: pageUrl
    });

    this.metaService.updateTag({
      property: 'og:image',
      content: pageImage
    });

    this.metaService.updateTag({
      property: 'og:type',
      content: 'website'
    });
    
    // Canonical Tag
    this.setCanonicalURL(pageUrl);
  }

  setCanonicalURL(url: string) {
    let link: HTMLLinkElement | null =
      this.document.querySelector("link[rel='canonical']");

    if (link) {
      link.setAttribute('href', url);
    } else {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', url);
      this.document.head.appendChild(link);
    }
  }

  private applyLandingPageSchema(): void {
    const base = this.schemaService.baseUrl;
    const graph: any[] = [
      this.schemaService.buildOrganization(),
      this.schemaService.buildWebSite(),
      {
        '@type': 'WebPage',
        '@id': `${base}/#webpage`,
        url: `${base}/`,
        name: 'Creative Stall | 3D Icons, Lottie Animations & Illustrations',
        description:
          'A marketplace for creative assets. Download free & premium SVG icons, illustrations, 3D graphics, and Lottie animations to speed up your design workflow.',
        isPartOf: { '@id': `${base}/#website` },
        about: { '@id': `${base}/#organization` },
        inLanguage: 'en-US',
        mainEntity: { '@id': `${base}/#categories` },
      },
      {
        '@type': 'ItemList',
        '@id': `${base}/#categories`,
        name: 'Asset Categories',
        numberOfItems: 5,
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '3D Graphics', url: `${base}/3d-graphics` },
          { '@type': 'ListItem', position: 2, name: 'Lottie Animations', url: `${base}/lottie-animations` },
          { '@type': 'ListItem', position: 3, name: 'Illustrations', url: `${base}/illustrations` },
          { '@type': 'ListItem', position: 4, name: 'Stickers', url: `${base}/stickers` },
          { '@type': 'ListItem', position: 5, name: 'Icons', url: `${base}/icons` },
        ],
      },
    ];
    this.schemaService.setSchema('landing-page', graph);
  }



  async getblobToken() {
    this.token = await firstValueFrom(this.blobService.getBlobToken());
  }
  async getliveSearch(evt:Event) {
    
     const input = evt.target as HTMLInputElement;
     const value = input.value.trim();
     this.isSearchOpen = true;

  // clear previous timeout
    clearTimeout(this.searchTimeout);

  // debounce (300ms)
  this.searchTimeout = setTimeout(() => {
    if (value.length > 0) {
      this.getliveSearchs(value);
    } else {
      this.liveSearch = [];
    }
    }, 300);
  }
selectSearch(value: string) {
  this.search = value;
  this.isSearchOpen = false; 
}
handleKeyDown(event: KeyboardEvent) {
  const list = this.liveSearch.length
    ? this.liveSearch
    : this.topSearchKeywords.map(x => x.searchKeyword);

  if (!list.length) return;

  switch (event.key) {
    case 'ArrowDown':
      event.preventDefault();
      this.activeIndex = (this.activeIndex + 1) % list.length;
      this.search = list[this.activeIndex];
      break;

    case 'ArrowUp':
      event.preventDefault();
      this.activeIndex =
        this.activeIndex <= 0 ? list.length - 1 : this.activeIndex - 1;
      this.search = list[this.activeIndex];
      break;

    case 'Enter':
      if (this.activeIndex >= 0) {
        this.selectSearch(list[this.activeIndex]);
      }
      break;

    case 'Escape':
      this.isSearchOpen = false;
      break;
  }
}
async getliveSearchs(value: string) {
  
  const live =
    SpecialCharactersFormatter.replaceAndSanitizeSpecialCharacters(value);

  this.liveSearch = await firstValueFrom(
    this.packService.getLiveSearch(live)
  );
}
  getTopSearchKeywords() {
    this.keywordsLoading = true;
    this.cacheService.getTopSearchKeywordsFromCache().subscribe({
      next: (response: TopSearchKeywords[]) => {
        this.topSearchKeywords = response;
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {
        setTimeout(() => {
          this.keywordsLoading = false;
          this.cdr.detectChanges();
        }, 10);
      },
    });
  }
  getTopSearchANDViews() {
    this.keywordsLoading = true;
    this.publicService.getTopSearchANDView().subscribe({
      next: (response: TopSearchANDViews) => {

        this.topSearchsKeywords = response.topSearchKeywords;
        this.topSearch=response.searchsCollection;
        this.iconPackDetail=response.iconPackDetails;
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {
        setTimeout(() => {
          this.keywordsLoading = false;
          this.cdr.detectChanges();
        }, 10);
      },
    });
  }
    deleteSearch(search:string) {
      this.publicService.deleteSearch(search)
        .subscribe(
          (response: boolean) => {
            this.getTopSearchANDViews()
          },
          error => {
            console.error('Error in Delete Search:', error);
          }
        );
  }
  private uniqueCategoriesById(list: Category[]): Category[] {
    const seen = new Set<string | number>();
    const out: Category[] = [];
    for (const c of list) {
      const key = c.categoryID != null ? c.categoryID : `n:${c.name ?? ''}`;
      if (seen.has(key)) {
        continue;
      }
      seen.add(key);
      out.push(c);
    }
    return out;
  }

  private uniquePackCategoriesById(list: CategoryPackVM[]): CategoryPackVM[] {
    const seen = new Set<string | number>();
    return list.filter((row) => {
      const c = row.category;
      const key =
        c?.categoryID != null ? c.categoryID : `n:${c?.name ?? ''}`;
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
  }

  getCategoriesFromCache() {
    this.categoryLoading = true;
    this.cacheService.getCategoriesFromCache().subscribe({
      next: (response: Category[]) => {
        this.categories = this.uniqueCategoriesById(response);
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {
        setTimeout(() => {
          this.categoryLoading = false;
          this.cdr.detectChanges();
        }, 10);
      },
    });
  }
  async getCategoryPacks() {
    this.loading = true;
    try {
      const rows = await firstValueFrom(this.packService.getCategoryPacks());
      this.packCategories = this.uniquePackCategoriesById(rows);
    } catch (err) {
      console.error('Error loading contributor info:', err);
      if (err instanceof HttpErrorResponse) {
              if (err.status === 400) {
                this.router.navigate([...ERROR_ROUTE_SEGMENTS.badrequest]);
              } 
              else if (err.status === 404) {
                this.router.navigate([...ERROR_ROUTE_SEGMENTS.notFound]);
              } else if (err.status === 500 || err.status===0) {
                this.router.navigate([...ERROR_ROUTE_SEGMENTS.serverError]);
              }
            }
    } finally {
      setTimeout(() => {
        this.loading = false;
        this.cdr.detectChanges();
      }, 10);
    }
  }

  changeSearch(evt: Event): void {
    const inputElement = evt.target as HTMLInputElement;
    const trimmedValue = inputElement.value.trim();
    inputElement.value = trimmedValue;
    this.search =
      SpecialCharactersFormatter.replaceAndSanitizeSpecialCharacters(
        trimmedValue
      );
    if (this.search.length) {
      this.sharedService.changeSearch(this.search);
      this.navigateToAssetGallery(this.search);
    }
  }
  OnEnterSearch(): void {
    this.search =
      SpecialCharactersFormatter.replaceAndSanitizeSpecialCharacters(
        this.search.trim()
      );
    if (this.search.trim().length) {
      this.navigateToAssetGallery(this.search);
    }
  }
  // onClickTrendingSearch(item:TopSearchKeywords):void{
  //   this.navigateToAssetGallery(item.searchKeyword);
  // }
  handlePaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData;
    if (clipboardData) {
      const items = clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        if (items[i].kind === 'file') {
          event.preventDefault();
          return;
        }
      }
    }
  }

  // Toggle a specific dropdown
  toggleDropdown2(id: string, event: Event): void {
    event.stopPropagation(); // Prevent the document click listener from closing the dropdown
    this.clearScrollCloseTimer(); // user-driven open/close should behave normally
    this.dropdownService.toggleDropdown(id);
  }

  // Check if a dropdown is visible
  isDropdownVisible(id: string): boolean {
    return this.dropdownService.isDropdownVisible(id);
  }
  async getPackages() {
    if(this.isUserLogin){

      const response = await firstValueFrom(this.packageService.getPackages());
      this.packages = response;
      const subscribedPackage = this.packages.find(p => p.subscribed && p.name === 'Free');
      this.subscribedPackage = subscribedPackage?.subscribed! ;
    }
    else{
      this.subscribedPackage=true;
    }

  }
  // Hide all dropdowns when clicking anywhere else in the document
  @HostListener('document:click')
  onDocumentClick(): void {
    this.dropdownService.hideAllDropdowns();
  }

  // Close the open asset/category dropdown ~2s after the user scrolls.
  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (!this.isDropdownVisible('heroSearch') || this.scrollCloseTimer) {
      return;
    }
    this.scrollCloseTimer = setTimeout(() => {
      this.scrollCloseTimer = null;
      if (this.isDropdownVisible('heroSearch')) {
        this.dropdownService.hideDropdown('heroSearch');
        this.cdr.markForCheck();
      }
    }, 1000);
  }

  private scrollCloseTimer: any = null;

  // Cancel a pending scroll-triggered close so manual open/close stays instant.
  private clearScrollCloseTimer(): void {
    if (this.scrollCloseTimer) {
      clearTimeout(this.scrollCloseTimer);
      this.scrollCloseTimer = null;
    }
  }

  navigateToAssetGallery(value: string): void {
    let params: AssetGalleryParams = {
      category: this.categorySelected,
      search: value,
    };
    if(this.content==='all' || this.content==='None' || this.content===''){
      AppRoutesUtils.Asset.navigateToAssetGallery(params);
    }
    else{

      const queryParams: { [key: string]: any } = {
        content: this.content,
      };
      AppRoutesUtils.Asset.navigateToAssetGalleryViaParams(params, queryParams);
    }
  }
  getAssetGalleryPathWithParams(value: string,category:string|null=null): string[] | null {
    let params: AssetGalleryParams = {
      category: category ? category : this.categorySelected ,
      search: value,
    };
    return AppRoutesUtils.Asset.getAssetGalleryViaParams(params);
  }
getAssetGalleryQueryParams(): { [key: string]: string } | null {
  if (this.content === 'all' || this.content === 'None' || this.content === '') {
    return null;
  }
  return { content: this.content };
}
  navigateToIconGallery(item: IconPack, catgeory: Category): void {
    AppRoutesUtils.Icon.navigateToIconGallery(item, catgeory);
  }
  navigateToPackGallery(item: Category): void {
    AppRoutesUtils.Pack.navigateToPackGallery(item);
  }
  getPackGalleryPath(item: Category): string[] | null {
    return AppRoutesUtils.Pack.getPackGalleryPath(item);
  }
goToPack(item: string) {
  const route = AppRoutesUtils.Pack.getTOPackGalleryPath(item);
  if (route) {
    this.router.navigate(route);
  }
}

openInNewTab(event: MouseEvent, item: string) {
  if (!this.isBrowser) return;
   if (event.button === 1 || event.button === 2) {
     event.preventDefault();
     const url = this.router.serializeUrl(
       this.router.createUrlTree(['/', FormatterUtil.formatToKebabCase(item)])
     );
     window.open(url, '_blank');
   }
}


onSelectLicenseType(content: string): void {
  if (this.content === content) {
    this.content = ''; 
    this.sharedService.setContent(this.content);

  } else {
    this.content = content;
    this.sharedService.setContent(this.content);
  }
}
  onSelectCategory(category: string): void {
    this.categorySelected = category;
     this.sharedService.setCategory(this.categorySelected);
  }

  @HostListener('window:resize')
  onResize() {
    if (!this.isBrowser) return;
    this.updateDeviceWidth();
  }
    updateDeviceWidth() {
    if (!this.isBrowser) return;

    this.screenWidth = window.innerWidth;
    this.isMobileView = this.screenWidth < 1280;

    this.updateVisibleCount();
  }

  /** Cards visible at once in the strip (1 on phones, 2 from md). */
  private getCardsPerView(): number {
    const el = this.cardsStrip?.nativeElement;
    const first = el?.firstElementChild as HTMLElement | null;
    if (!el || !first?.offsetWidth) return 1;
    return Math.max(1, Math.round(el.clientWidth / first.offsetWidth));
  }

  /** One dot per page of cards, not per card, so tablets show 3 dots for 5 cards. */
  get cardDots(): number[] {
    const pages = Math.ceil(this.categories.length / this.getCardsPerView());
    return Array.from({ length: pages }, (_, i) => i);
  }

  onCardsScroll(): void {
    const el = this.cardsStrip?.nativeElement;
    const first = el?.firstElementChild as HTMLElement | null;
    if (!el || !first) return;
    const perView = this.getCardsPerView();
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 2;
    const index = atEnd
      ? this.categories.length - 1
      : Math.round(el.scrollLeft / first.offsetWidth);
    const page = Math.floor(index / perView);
    if (page !== this.activeCardIndex) {
      this.activeCardIndex = page;
    }
  }

  scrollToCard(page: number): void {
    const el = this.cardsStrip?.nativeElement;
    const card = el?.children[page * this.getCardsPerView()] as HTMLElement | undefined;
    if (!el || !card) return;
    el.scrollTo({ left: card.offsetLeft - el.offsetLeft, behavior: 'smooth' });
  }
  
  private packGridLayoutSub = Subscription.EMPTY;
  ngOnDestroy(): void {
       this.packGridLayoutSub.unsubscribe();
  this.clearScrollCloseTimer();
  if (isPlatformBrowser(this.platformId)) {
    window.removeEventListener('scroll', this.scrollHandler);
  }
  this.HeaderSearchService.setHeaderSearchState(true);
  
  // ✅ When leaving landing page, always show header search
  this.HeaderSearchService.setHeaderSearchState(true);
  this.schemaService.removeSchema('landing-page');
  }
  openPopup(templateRef: TemplateRef<any>, event: MouseEvent) {
  const target = event.target as HTMLElement;
  const rect = target.getBoundingClientRect();
  this.dialog.open(templateRef, {
    width: '870px',
    height: 'auto',
    maxHeight: '90vh',
    hasBackdrop: false, // makes it dropdown-like
    panelClass: 'search-dropdown',
    position: {
      top: rect.bottom + 'px',
      left: rect.left + 'px'

    }
  });
  }
  getFirstKeyword(item:IconPackDetail):string {
    return item.keyword?.split(',')[0].trim() || '';
  }

    @ViewChild('heroSection') heroSection!: ElementRef;
  heroheight: number = 0;
   // These are already correct — just make sure all 3 are present:

  ngAfterViewInit() {
    this.getHeroHeight();

    if (this.isBrowser) {
      this.updateVisibleCount();

      this.ngZone.runOutsideAngular(() => {
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
      });
    }
  }

  getHeroHeight() {
   if (this.heroSection) {
      this.heroheight = this.heroSection.nativeElement.offsetHeight;
    }
  }
getFestivities(): void {
  this.isFestivitiesLoading = true;
  this.cacheService.getEventCategoriesFromCache().subscribe({
    next: (response: EventCategory[]) => {
      const parents = response.filter(x => x.eventCategoryParentID === -1);
      const children = response.filter(x => x.eventCategoryParentID !== -1);

      this.parentFestivities = parents.map(parent => ({
        ...parent,
        children: children.filter(
          c => c.eventCategoryParentID === parent.eventCategoryID
        ),
      }));

    },
    error: () => {
      this.parentFestivities = [];
    },
    complete: () => {
      this.isFestivitiesLoading = false;
      this.cdr.detectChanges();
      // Measure #festivityGrid after it is in the DOM (same as pack rows).
      setTimeout(() => this.updateVisibleCount(), 0);
    }
  });
}
  goToEventGallery(eventName: string): void {
    const path = AppRoutesUtils.Pack.getEventPackGalleryPath(eventName);
    if (path) {
      this.router.navigate(path);
    }
  }
isSmallScreen(): boolean {
  if (!isPlatformBrowser(this.platformId)) {
    return false;
  }
  return window.innerWidth < 1024;
}
onScroll() {
  // Same show/hide rule on every breakpoint — show after scrolling past the
  // hero, hide again when back at the top. Previously the small-screen branch
  // forced `true` on every scroll, so the mobile search bar latched open and
  // never re-hid at the top.
  const shouldShow = window.scrollY > this.heroheight;
  // Only re-enter the Angular zone when the state flips, not on every scroll event.
  if (shouldShow === this.lastHeaderSearchShown) {
    return;
  }
  this.lastHeaderSearchShown = shouldShow;
  this.ngZone.run(() => {
    this.HeaderSearchService.setHeaderSearchState(shouldShow);
    this.cdr.markForCheck();
  });
}
private lastHeaderSearchShown?: boolean;
getname(item:string){
  return FormatterUtil.formatToKebabCase(item)
}
  @ViewChildren('packGrid', { read: ElementRef })
  packGrids!: QueryList<ElementRef<HTMLElement>>;
  @ViewChildren('festivityGrid', { read: ElementRef })
  festivityGrids!: QueryList<ElementRef<HTMLElement>>;
  visibleCount: number = 5;

  private getPackRowGridElement(): HTMLElement | undefined {
    return (
      this.packGrids?.first?.nativeElement ??
      this.festivityGrids?.first?.nativeElement
    );
  }

  /** Measured grid width; reading offsetWidth on every change detection forced a layout each time. */
  private measuredPackRowWidth?: number;

  private getPackRowContainerWidth(): number {
    if (this.measuredPackRowWidth !== undefined) {
      return this.measuredPackRowWidth;
    }
    const w = isPlatformBrowser(this.platformId) ? window.innerWidth : 1280;
    const el = this.getPackRowGridElement();
    const fallbackWidth = w - 104 * 2;
    if (el) {
      // Only remember a real measurement, not the fallback used before the grid exists.
      this.measuredPackRowWidth = el.offsetWidth;
      return this.measuredPackRowWidth;
    }
    return Math.max(320, fallbackWidth);
  }

  private countPackRowColumns(containerWidth: number): number {
    return Math.max(
      1,
      Math.floor(
        (containerWidth + this.packGridGapPx) /
          (this.packGridMinPx + this.packGridGapPx)
      )
    );
  }

  updateVisibleCount(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const w = window.innerWidth;
    const next =
      w < 1024
        ? 999
        : this.countPackRowColumns(this.getPackRowContainerWidth());
    if (this.visibleCount !== next) {
      this.visibleCount = next;
      this.cdr.markForCheck();
    }
  }

  packSkeletonLoaderCount(): number {
    if (!this.isBrowser) {
      return this.packRowTabletMax;
    }
    const w = window.innerWidth;
    if (w < 768) {
      return 8;
    }
    if (w < 1024) {
      return this.packRowTabletMax;
    }
    return this.countPackRowColumns(this.getPackRowContainerWidth());
  }
private getScreenWidth(): number {
  
  // ✅ Browser: use real window width
  if (isPlatformBrowser(this.platformId)) {
    return window.innerWidth;
  }

  // ✅ SSR: read User-Agent from request headers
  const ua = this.request?.headers?.get('user-agent') ?? '';

  if (/Mobile|Android|iPhone/i.test(ua)) {
    return 480;   // → mobile path
  }
  if (/iPad|Tablet/i.test(ua)) {
    return 768;   // → tablet path
  }
  return 1280;    // → desktop path (default for unknown)
}
  private visibleRowItems<T>(items: T[]): T[] {
    if (!items?.length) {
      return [];
    }
    const w = this.getScreenWidth();

    if (w < 768) {
      return items;
    }
    if (w < 1024) {
      return items.slice(0, Math.min(this.packRowTabletMax, items.length));
    }

    const max = Math.max(1, this.visibleCount);
    return items.slice(0, Math.min(max, items.length));
  }

  visiblePacks(packs: IconPack[]): IconPack[] {
    return this.visibleRowItems(packs);
  }

  visibleFestivityChildren(
    children: EventCategory[] | undefined | null
  ): EventCategory[] {
    if (!children?.length) {
      return [];
    }
    return this.visibleRowItems(children);
  }
}
